import { Checkbox } from "@chakra-ui/react";
import { FieldComponentProps } from "./types";

export function FieldCheckbox(props: FieldComponentProps) {
  return (
    <Checkbox
      isChecked={props.value === "Ja"}
      id={props.id}
      name={props.label}
      onChange={() => {
        props.updateValue({
          label: props.label,
          value: props.value === "Ja" ? "Nein" : "Ja",
        });
      }}
      isInvalid={props.isInvalid}
    >
      Ja
    </Checkbox>
  );
}
